/** URL values for the governed legacy MO exception classifications. */
export const MO_EXCEPTION_KEYS = [
  'nosmv',
  'nofob',
  'nofab',
  'noacc',
  'nomat',
  'matgtfob',
] as const;

export type MoExceptionKey = (typeof MO_EXCEPTION_KEYS)[number];

export function isMoExceptionKey(value: string | null): value is MoExceptionKey {
  return value !== null && MO_EXCEPTION_KEYS.some((key) => key === value);
}
